
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import ChatQueueClearFrom from '@/services/QA/chat-queue-settings/forms/ChatQueueClearFrom';
import ChatRepositoryInterface from '@/services/QA/chat/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'chatRepository',
  ],
})
export default class ChatQueueSettings extends Vue {
  private chatQueueClearForm: WPXFormValue<ChatQueueClearFrom> = new WPXFormValue(ChatQueueClearFrom);
  private chatQueueClearDateMenu: boolean = false;
  private loading: boolean = true;

  private chatRepository!: ChatRepositoryInterface;
  private dryRunResult: boolean = false;
  private chatsFoundCount: number = 0;

  public created(): void {
    this.loading = false;
  }

  private async dryRun(): Promise<void> {
    const timestamp = this.getTimestamp();
    this.chatsFoundCount = await this.chatRepository.clearChatQueue(
      timestamp,
      true,
    );

    this.dryRunResult = true;
  }

  private async clearChatQueue(): Promise<void> {
    const timestamp = this.getTimestamp();
    await this.chatRepository.clearChatQueue(timestamp, false);
    this.$successDialog.show(`Chat Queue Clear Started.`);
    this.chatQueueClearForm.data.date = '';
    this.dryRunResult = false;
  }

  private getTimestamp(): number {
    const date = new Date(new Date(this.chatQueueClearForm.data.date));
    date.setDate(date.getDate() - 1);
    date.setHours(23, 59, 59);
    return Math.floor(date.getTime() / 1000);
  }

  private clearResult(): void {
    this.chatsFoundCount = 0;
    this.dryRunResult = false;
  }
}
